<template>
    <div class="course-list mg-top1 clearfix pt-3 pb-3 home-bg">
        <div class="" style="margin-left: 2%; margin-right: 2%;">
            <div class="title-section">
                <div class="flat-title larger">Individual courses</div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-12">
                    <div class="sidebar-left sidebar-course">
                        <div class="widget widget-categories">
                            <div class="widget-title">
                                Course Categories
                            </div>
                            <div class="content">
                                <ul>
                                    <li :class="{selected : (selectedCategory == null)}" v-on:click="selectCategory(null)">
                                        All Categories
                                        <span class="numb-left">{{ courses.length }}</span>
                                    </li>

                                    <li v-for="category in categories"
                                        :class="{selected : (category.name == selectedCategory)}"
                                        v-on:click="selectCategory(category.name)">
                                        {{ category.name ? category.name : "No category" }}
                                        <span class="numb-left">{{ category.count }}</span>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-md-12">
                    <div class="content-course-list">
                        <course-card-component v-for="course in courses"
                                               :course="course"
                                               :key="course.id"
                                               v-if="selectedCategory == null || selectedCategory  == course.category" />
                    </div>
                </div>
            </div>
        </div>
        <div class="container">


        </div>
    </div><!-- course-list -->
</template>

<style scoped>
    .selected {
        color: #3d3c79;
    }

    .widget-title {
        color: #3d3c79;
    }

    li {
        cursor: pointer;
    }
</style>

<script>

    export default {
        name: 'CoursesIndex',
        components: {
        },
        props: {

        },
        data() {
            return {
                selectedCategory: null,
                courses: [],
                coursePackages: []
            }
        },
        methods: {
            selectCategory(category) {
                var setCategory = category;
                if (setCategory) {
                    setCategory = setCategory.replaceAll(" ", "");
                    var split = setCategory.split(/(?=[A-Z])/);
                    if (split.length > 1) {
                        setCategory = "";

                        for (var i = 0; i < split.length; i++) {
                            setCategory += split[i];
                            if (i + 1 < split.length) {
                                setCategory += " ";
                            }
                        }
                    }
                }

                console.log(category);
                this.selectedCategory = setCategory;
            },
        },
        computed: {
            categories() {
                var categories = [];
                if (this.courses) {
                    for (var i = 0; i < this.courses.length; i++) {
                        var course = this.courses[i];
                        var existing = categories.find(x => x.name == course.category);
                        if (existing) {
                            existing.count++;
                        }
                        else {
                            categories.push({
                                name: course.category,
                                count: 1
                            });
                        }
                    }

                    categories.sort((a, b) => a.name < b.name ? -1 : 1);
                }

                return categories;
            },
            siteDesign() {
                return this.$store.state.siteDesign;
            }
        },
        async mounted() {
            this.courses = await this.web("/courses?filters=none", "Loading courses");
            this.coursePackages = await this.web("/coursePackages", "Loading course packages");

            this.$store.commit("breadCrumbs", { "/courses": "Courses" });
            $(".bg-header").css("background-image", "url(https://fabricfour.blob.core.windows.net/mhslearning-upload/" + this.siteDesign.homePage.bannerFileName + ")");
        }
    }

</script>
